import {
    GETSMSPROVIDERDROPDOWN_SUCCESS,
    GETSMSPROVIDERDROPDOWN_FAILED,
    RESET_GETSMSPROVIDERDROPDOWN,
    LOADING_GETSMSPROVIDERDROPDOWN,
    NETWORK_GETSMSPROVIDERDROPDOWN,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetSMSProviderDropDown = () => {
    return { type: RESET_GETSMSPROVIDERDROPDOWN };
};

const getSMSProviderDropDown = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETSMSPROVIDERDROPDOWN });
    await adminServices
        .post("getSmsProvider", userData, { headers: { AuthToken: authTokenIs } })

        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getSmsProviderSuccessDropDown(res.data));
                    break;
                default:
                    dispatch(getSmsProviderFailedDropDown(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_GETSMSPROVIDERDROPDOWN, payload: err });
        });
};

function getSmsProviderSuccessDropDown(data) {
    return {
        type: GETSMSPROVIDERDROPDOWN_SUCCESS,
        payload: data,
    };
}

function getSmsProviderFailedDropDown(data) {
    return {
        type: GETSMSPROVIDERDROPDOWN_FAILED,
        payload: data,
    };
}

export { resetGetSMSProviderDropDown, getSMSProviderDropDown };
